<script>
	import '@kitware/vtk.js/Rendering/Profiles/Geometry';
	import '@kitware/vtk.js/Rendering/Profiles/Volume';
	import vtkGenericRenderWindow from '@kitware/vtk.js/Rendering/Misc/GenericRenderWindow';
	import vtkMapper from "@kitware/vtk.js/Rendering/Core/Mapper";
	  import vtkActor from "@kitware/vtk.js/Rendering/Core/Actor";
	import vtkSphereSource from '@kitware/vtk.js/Filters/Sources/SphereSource';
	import vtkInteractorStyleManipulator from '@kitware/vtk.js/Interaction/Style/InteractorStyleManipulator'
	import vtkMouseCameraTrackballPanManipulator from "@kitware/vtk.js/Interaction/Manipulators/MouseCameraTrackballPanManipulator";
	import vtkMouseCameraTrackballRollManipulator from "@kitware/vtk.js/Interaction/Manipulators/MouseCameraTrackballRollManipulator";
	import vtkMouseCameraTrackballRotateManipulator from "@kitware/vtk.js/Interaction/Manipulators/MouseCameraTrackballRotateManipulator";
	import vtkMouseCameraTrackballZoomManipulator from "@kitware/vtk.js/Interaction/Manipulators/MouseCameraTrackballZoomManipulator";
  
  
	import { onMount } from 'svelte';
	
  
	//global variables
	let m_rendererContainer; //container
	
	// vtk renderwindow, renderer
	const m_genericRenderWindow = vtkGenericRenderWindow.newInstance();
	const m_renderer = m_genericRenderWindow.getRenderer();
	const m_renderWindow = m_genericRenderWindow.getRenderWindow();
	const m_interactor = m_genericRenderWindow.getInteractor();
	const interactorStyle = vtkInteractorStyleManipulator.newInstance();
	m_interactor.setInteractorStyle(interactorStyle);
	
	interactorStyle.addMouseManipulator(
	  vtkMouseCameraTrackballRotateManipulator.newInstance({
		button: 3,
	  })
	);
	interactorStyle.addMouseManipulator(
	  vtkMouseCameraTrackballPanManipulator.newInstance({
		button: 1,
	  })
	);
	interactorStyle.addMouseManipulator(
	  vtkMouseCameraTrackballRollManipulator.newInstance({
		button: 3,
		control: true,
	  })
	);
	interactorStyle.addMouseManipulator(
	  vtkMouseCameraTrackballZoomManipulator.newInstance({
		button: 2,
	  })
	);
	interactorStyle.addMouseManipulator(
	  vtkMouseCameraTrackballZoomManipulator.newInstance({
		scrollEnabled: true,
		dragEnabled: false,
	  })
	);
  
	
	
	onMount(async ()=>{				
	
	  //connnect vtkrenderer
	  m_genericRenderWindow.getRenderer().setBackground(0, 0, 0, 0);
	  m_genericRenderWindow.setContainer(m_rendererContainer);
	  m_genericRenderWindow.resize();
	});
  
	function loadFile()
	{
		const sphere = vtkSphereSource.newInstance();
		sphere.setCenter(0,0,0);
		sphere.setRadius(10);
		sphere.update();
		console.log("sphere : ", sphere.getOutputData().getBounds())
  
		const mapper = vtkMapper.newInstance();
		mapper.setInputData(sphere.getOutputData());
  
		const actor = vtkActor.newInstance();
		actor.setMapper(mapper);
		actor.getProperty().setColor(1,0,0);
  
		m_renderer.addActor(actor);
  
		
		m_renderer.resetCamera();
		m_genericRenderWindow.resize();
		m_renderWindow.render();
	}
  
</script>
	


<div class="renderer" bind:this={m_rendererContainer}>
    <button class="vtkbutton" on:click={() => loadFile()} >Show</button>
</div>





<style>

.renderer{
    width: 100%;
    height : 100%;
    background-color: #e47011;

	padding: 0;
}	

</style>